import { useContext } from "react"
import { LanguageContext } from "./LanguageContext"

export const useLanguageContext = () => useContext(LanguageContext)
//export default useLanguageContext
